import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'primereact/message';
import { PickList } from 'primereact/picklist';
import { formikFieldShape } from '../prop-types';

const PrimeReactErrorMessage = ({ msg }) => <Message severity="error" text={msg} />;

PrimeReactErrorMessage.propTypes = {
  msg: PropTypes.string.isRequired,
};

class FormikPickList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: [],
      target: [],
    };
    this.changePickList = this.changePickList.bind(this);
  }

  componentDidMount() {
    const { source = [], target = [] } = this.props;
    this.setState({ source, target });
  }

  changePickList(e) {
    const { source = [], target = [] } = e;
    const {
      setFieldValue,
      field: { name },
    } = this.props;

    const newSource = source.sort((a, b) => a.displayName.localeCompare(b.displayName)).slice();
    const newTarget = target.sort((a, b) => a.displayName.localeCompare(b.displayName)).slice();

    this.setState({
      source: newSource,
      target: newTarget,
    });

    setFieldValue(name, newTarget);
  }

  render() {
    const {
      field, setFieldValue, template, form: { errors }, ...rest
    } = this.props;
    const { source, target } = this.state;

    return (
      <React.Fragment>
        <PickList
          {...field}
          {...rest}
          source={source}
          target={target}
          itemTemplate={(item) => {
            if (template) {
              return template(item);
            }
            return null;
          }}
          onChange={this.changePickList}
          responsive
        />

        {
          errors[field.name] && (<PrimeReactErrorMessage msg={errors[field.name]} />)
        }

      </React.Fragment>
    );
  }
}

FormikPickList.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  source: PropTypes.arrayOf(PropTypes.any),
  target: PropTypes.arrayOf(PropTypes.any),
  field: formikFieldShape.isRequired,
  idKey: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  template: PropTypes.func,
};

FormikPickList.defaultProps = {
  source: [],
  target: [],
  template: null,
};

export default FormikPickList;
